module.exports = __webpack_public_path__ + "static/img/ability02.850c2ceb.webp";